import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://db.onlinewebfonts.com/c/545e2d6eac66c6985c113d4656797e49?family=Shaikh+Hamdullah+Mushaf');
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  :root{
    --primary: #1d6ec7;
    --secondary: #ffa335;
    --darkBlue: #070747;
    --darkPurple: #0E0034;
    --black-1: rgb(240, 242, 245);
    --black-2: #1d6ec7;
    --white-1: #C6BED9;
    --gray: #283739;
    --grey: var(--gray);
    --white: #121826;
    --black: black;
    --basmalah-font: 'Shaikh Hamdullah Mushaf', serif;
  }
  html{
    font-size: 10px;
    -webkit-text-size-adjust: 100%;
  }
  body{
    min-height: 100vh;
    line-height: 1.5;
    width: 100%;
    font-family: 'Inter', sans-serif;
    background: var(--black-1);
    color: var(--white);
    overflow-x: hidden;
  }
  a{
    text-decoration: none;
    color: var(--white);
  }
  .container{
    max-width: 1200px;
    margin: 0 auto;
    width: 90%;
    padding: 0;
  }
  img{
    max-width: 100%;
    height: auto;
    display: block;
  }
  svg{
    display: inline-block;
    vertical-align: middle;
  }
  li, ul{
    list-style: none;
  }

  @media only screen and (max-width: 480px) {
    .container {
      width: 94%;
    }
  }
`;

export default GlobalStyles;
